export default "__VITE_ASSET__c75mRSOb__"